import { StateNodeConfig } from '@sierralabs/workflow';
import { Task } from './Task.interface';

export type TaskMap = {
  [name in string]: Task[];
};

export const createEmptyTaskMap = (
  array: StateNodeConfig<Document, any>[] = []
): TaskMap => {
  const initialValue = {};

  return array.reduce((obj: any, item: any) => {
    return {
      ...obj,
      [item.name]: []
    };
  }, initialValue);
};

export const mapTaskByStatus = (
  workflow: StateNodeConfig<Document, any>[] = [],
  task: Task[],
  taskMap?: TaskMap
): TaskMap => {
  taskMap = (taskMap || { ...createEmptyTaskMap(workflow) }) as TaskMap;

  return task.reduce((taskMap: TaskMap, task: Task) => {
    const status = parseTaskStatus(task?.status);
    if (status) {
      if (!taskMap[status]) {
        taskMap[status] = [];
      }
      taskMap[status].push(task);
    }
    return taskMap;
  }, taskMap);
};

export const parseTaskStatus = (status: string): string => {
  if (!status.includes('/')) return status;
  const stringArray = status.split('/');
  return stringArray[stringArray.length - 1];
};

// parse status for cases where workflow was renamed (e.g. status log)
export function compareTaskStatus(a: string, b: string) {
  return a === b || parseTaskStatus(a) === parseTaskStatus(b);
}

// make sure subTask is active based on the task status and version
export function isSubTaskInActiveStatePath(
  subTask: Pick<Task, 'version' | 'statePath'>,
  parent: Pick<Task, 'version' | 'status'>
) {
  return (
    (!subTask.version ||
      !parent.version ||
      subTask.version === parent.version) &&
    (!subTask.statePath || compareTaskStatus(subTask.statePath, parent.status))
  );
}
